import React, { Component } from 'react';
import {
  FilterButton,
  FilterContent,
  DateRangeWrapper,
  DateRangeIconWrapper,
  SelectWrapper,
  FilterActionWrapper,
  ClearButton
} from './styledComponents';
import Icon from 'components/Icon';
import Popover from 'components/Popover';
import { colors } from 'globalStyles'
import InputField, { Select, Date } from 'components/InputField';
import { Field, reduxForm, reset } from 'redux-form';
import Button from 'components/Button';
import { selectIsFetching, selectAllChannels } from '../../ChannelsPage/selectors';
import { fetchChannelDetailRequest, fetchChannelsRequest } from '../../ChannelsPage/actions';
import { createStructuredSelector } from 'reselect';
import { mapIsEmpty } from 'utils/helpers';
import { connect } from 'react-redux';
import { change } from "redux-form";

const FilterInput = ({ label, type, children, ...props }) => {
  var content = children;
  switch (type) {
    case 'date_range':
      content = (
        <DateRangeWrapper>
          <DateRangeIconWrapper>
            <Icon name='calendar' size='14' viewBox='0 0 14 14' />
            <Icon name='calendar' />
          </DateRangeIconWrapper>
          <Date isDateRangeMode {...props} customArrowIcon={<Icon name='-' size='20' />} />
        </DateRangeWrapper>
      );
      break;
    case 'select':
      content = (
        <SelectWrapper>
          <Select {...props} placeholder='all my channels' />
        </SelectWrapper>
      );
      break;
  }
  return (
    <div>
      <label>{label}</label>
      {content}
    </div>
  )
}

class Filter extends Component {
  state = {
    channelOptions: []
  }

  componentDidMount() {
    const { match: { params: { channelId } } } = this.props;
      if (channelId) {
      this.props.fetchDetail(channelId)
    }
  }

  componentDidUpdate(prevProps) {
    const newChannels = this.getChannels(this.props.channels);
    if (JSON.stringify(this.getChannels(prevProps.channels)) !== JSON.stringify(newChannels) || (this.state.channelOptions.length === 0 && !mapIsEmpty(prevProps.channels))) {
      this.setState({ channelOptions: this.props.channelPaging.currentPage === 1 ? newChannels : [...this.state.channelOptions, ...newChannels] })
    }
    const { formData, filterSubmit } = this.props;
    const oldFormData = prevProps.formData;
    const newFilter = formData && (formData.dateRange || formData.sourceChannel || formData.search);
    const oldFilter = oldFormData && (oldFormData.dateRange || oldFormData.sourceChannel || oldFormData.search);
    if(oldFilter && !newFilter) {
      filterSubmit();
    }
    
    if ((!prevProps.channelDetail && this.props.channelDetail) || JSON.stringify(prevProps.channelDetail) !== JSON.stringify(this.props.channelDetail)) {
      this.props.setInitChannelSource(this.props.channelDetail.id);
      this.setState({ channelOptions: [...this.state.channelOptions, { label: this.props.channelDetail.name, name: this.props.channelDetail.id }] })
    }
  }

  getChannels(channels) {
    const channelsEmpty = !channels || mapIsEmpty(channels);
    const channelsSource = channelsEmpty
      ? []
      : Object.keys(channels).map(k => ({ label: channels[k].name, value: channels[k].id })).filter(x => x.label);
    return channelsSource;
  }

  render() {
    const { filterSubmit, isFetching, fetchChannels, formData, resetForm, channelPaging } = this.props;

    const hasFilter = formData && (formData.dateRange || formData.sourceChannel || formData.search);
    return (
      <Popover>
        <FilterButton onClick={() => !isFetching && this.state.channelOptions.length === 0 && fetchChannels()}>
          <label>Filter</label>
          <Icon name='drop-down' size='12' fill={colors.DARK} />
        </FilterButton>
        {(toggleOpen) => <FilterContent>
          <div>
            <form>
              <Field
                name='date_range'
                type='date_range'
                label='date range'
                component={FilterInput}
              />
              <Field
                name='source_channel'
                type='select'
                label='source channel'
                component={FilterInput}
                fetchOptions={fetchChannels}
                pagingOptions={channelPaging}
                alwaysFetchOptions={true}
                options={this.state.channelOptions}
                isFetching={isFetching}
                enableDropDownIcon={true}
              />
              <FilterActionWrapper>
                <ClearButton
                  type='button'
                  onClick={() => {
                    if (hasFilter) {
                      resetForm();
                    }
                    toggleOpen();
                  }}>
                  {hasFilter ? 'Clear' : 'Cancel'}
                </ClearButton>
                <Button type='button' onClick={() => { toggleOpen(); filterSubmit(); }}>Apply</Button>
              </FilterActionWrapper>
            </form>
          </div>
        </FilterContent>}
      </Popover>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isFetching: selectIsFetching(),
  channels: selectAllChannels(),
  channelPaging: state => state.channels.paging,
  channelDetail: state => state.channels.channelDetail,
});

const mapDispatchToProp = (dispatch) => ({
  fetchChannels: (params) => dispatch(fetchChannelsRequest(params)),
  resetForm: () => dispatch(reset('lead_filter')),
  setInitChannelSource: (data) => dispatch(change("lead_filter", "source_channel", data)),
  fetchDetail: (id) => dispatch(fetchChannelDetailRequest(id)),
});

export default connect(mapStateToProps, mapDispatchToProp)(reduxForm({ form: 'lead_filter' })(Filter));


// WEBPACK FOOTER //
// ./src/containers/LeadsPage/LeadsList/Filter.js